import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { TransactionWithInstrument } from "@/types/Transaction";
import { HoldingWithInstrument } from "@/types/Holding";

interface TransactionsHoldingsCardProps {
  totalTransactions: number;
  confirmedTransactions: TransactionWithInstrument[];
  unconfirmedTransactions: TransactionWithInstrument[];
  totalHoldings: number;
  confirmedHoldings: HoldingWithInstrument[];
  unconfirmedHoldings: HoldingWithInstrument[];
}

export const TransactionsHoldingsCard: React.FC<TransactionsHoldingsCardProps> = ({
  totalTransactions,
  confirmedTransactions,
  unconfirmedTransactions,
  totalHoldings,
  confirmedHoldings,
  unconfirmedHoldings,
}) => {
  const navigate = useNavigate();

  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-muted/50 pb-4">
        <CardTitle className="flex items-center gap-2 text-lg">
          <LayoutDashboard className="h-5 w-5 text-blue-500" />
          Transactions & Holdings
        </CardTitle>
        <CardDescription>
          Overview of transactions and holdings for this period
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium">Transactions</p>
              <p className="text-3xl font-bold">
                {totalTransactions}
              </p>
              <div className="flex gap-2 mt-1">
                <Badge variant="outline" className="text-xs">
                  {confirmedTransactions.length} Confirmed
                </Badge>
                <Badge variant="outline" className="text-xs bg-amber-50">
                  {unconfirmedTransactions.length} Unconfirmed
                </Badge>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate("/app/transactions")}
            >
              View
            </Button>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium">Holdings</p>
              <p className="text-3xl font-bold">
                {totalHoldings}
              </p>
              <div className="flex gap-2 mt-1">
                <Badge variant="outline" className="text-xs">
                  {confirmedHoldings.length} Confirmed
                </Badge>
                <Badge variant="outline" className="text-xs bg-amber-50">
                  {unconfirmedHoldings.length} Unconfirmed
                </Badge>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate("/app/holdings")}
            >
              View
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}; 